export default __webpack_public_path__ + "static/media/clientes10.0c2cd918.png";